const operators: { [key: string]: Operator[] } = {
  string: [
    {
      alias: 'is',
      symbol: '=',
      type: 'string',
    },
    {
      alias: 'is not',
      symbol: '<>',
      type: 'string',
    },
    {
      alias: 'starts with',
      symbol: 'LIKE',
      suffix: '%',
      type: 'string',
    },
    {
      alias: 'ends with',
      symbol: 'LIKE',
      prefix: '%',
      type: 'string',
    },
    {
      alias: 'contains',
      symbol: 'LIKE',
      prefix: '%',
      suffix: '%',
      type: 'string',
    },
    {
      alias: 'does not contain',
      symbol: 'NOT LIKE',
      prefix: '%',
      suffix: '%',
      type: 'string',
    },
    {
      alias: 'is blank',
      symbol: 'IS NULL',
      omitValue: true,
      type: 'string',
    },
    {
      alias: 'is not blank',
      symbol: 'IS NOT NULL',
      omitValue: true,
      type: 'string',
    },
  ],
  number: [
    {
      alias: 'is',
      symbol: '=',
      type: 'number',
    },
    {
      alias: 'is not',
      symbol: '<>',
      type: 'number',
    },
    {
      alias: 'is at least',
      symbol: '>=',
      type: 'number',
    },
    {
      alias: 'is less than',
      symbol: '<',
      type: 'number',
    },
    {
      alias: 'is at most',
      symbol: '<=',
      type: 'number',
    },
    {
      alias: 'is greater than',
      symbol: '>',
      type: 'number',
    },
    {
      alias: 'is blank',
      symbol: 'IS NULL',
      omitValue: true,
      type: 'number',
    },
    {
      alias: 'is not blank',
      symbol: 'IS NOT NULL',
      omitValue: true,
      type: 'number',
    },
  ],
  date: [
    {
      alias: 'is on',
      fullDay: true,
      symbol: 'BETWEEN',
      type: 'date',
    },
    {
      alias: 'is not on',
      fullDay: true,
      symbol: 'NOT BETWEEN',
      type: 'date',
    },
    {
      alias: 'is before',
      symbol: '<',
      type: 'date',
    },
    {
      alias: 'is after',
      symbol: '>',
      type: 'date',
    },
    {
      alias: 'is on or before',
      symbol: '<=',
      type: 'date',
    },
    {
      alias: 'is on or after',
      symbol: '>=',
      type: 'date',
    },
    {
      alias: 'is blank',
      symbol: 'IS NULL',
      omitValue: true,
      type: 'date',
    },
    {
      alias: 'is not blank',
      symbol: 'IS NOT NULL',
      omitValue: true,
      type: 'date',
    },
    // {
    //   alias: "in the last",
    //   symbol: "BETWEEN",
    //   relativeDate: true,
    //   type: "date",
    // },
    // {
    //   alias: "not in the last",
    //   symbol: "NOT BETWEEN",
    //   relativeDate: true,
    //   type: "date",
    // },
  ],
  epoch: [
    // {
    //   alias: "is on",
    //   fullDay: true,
    //   symbol: "BETWEEN",
    //   type: "epoch",
    // },
    // {
    //   alias: "is not on",
    //   fullDay: true,
    //   symbol: "NOT BETWEEN",
    //   type: "epoch",
    // },
    // {
    //   alias: "is before",
    //   symbol: "<",
    //   type: "epoch",
    // },
    // {
    //   alias: "is after",
    //   symbol: ">",
    //   type: "epoch",
    // },
    // {
    //   alias: "is on or before",
    //   symbol: "<=",
    //   type: "epoch",
    // },
    // {
    //   alias: "is on or after",
    //   symbol: ">=",
    //   type: "epoch",
    // },
    // {
    //   alias: "is blank",
    //   symbol: "IS NULL",
    //   omitValue: true,
    //   type: "epoch",
    // },
    // {
    //   alias: "is not blank",
    //   symbol: "IS NOT NULL",
    //   omitValue: true,
    //   type: "epoch",
    // },
  ],
};
export default operators;
